import * as Http from "@/api/HttpService.js";
import { API } from "@/api/HttpConfig.js";

import {
  specialCodeHead,
  deepSeekHead,
  deepSeekFooter,
  imgContentHead,
} from "@/config/config";
import { businessCodeMatch } from "@/utils/businessCodeMatch";
import { previewImage } from "@/utils/previewImageForPC";

import { Toast } from "vant";
import record from "@/utils/record.js";
import copy from "clipboard-copy";
import lottie from "lottie-web";
import loadingJSON from "@/assets/loading.json";

import AudioPlayer from "@/common/js/AudioPlayer";
import cloneDeep from "clone-deep";


export default function createMethods(vm) {
  return {

    // 查询是否启用了游客模式
    async getSystemInfo() {
      let params = {
        system: window.localStorage.getItem("appId_AI"),
      };
      await Http.getSystemInfo(params)
        .then(({ res }) => {
          if (res.code == "SUCCESS") {
            vm.systemOpenGuestMode =
              res.originalData.data.guestChatLimit > 0 ? true : false;
            vm.guestChatLimit = res.originalData.data.guestChatLimit
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 游客登录
    async guestLogin() {
      // 生成UUID
      function generateUUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c == "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
          }
        );
      }
      // 先从缓存里取imei  如果没有则生成一个
      let imei = window.localStorage.getItem("guestImei") || generateUUID();
      let params = {
        system: window.localStorage.getItem("appId_AI"),
        imei,
      };
      await Http.guestLogin(params).then(({ res }) => {
        console.log(res);
        if (res.code == "SUCCESS") {
          vm.isLogin = true;
          vm.loginType = 2;
          window.localStorage.setItem(
            "sessionId_AI",
            res.originalData.data.sessionId
          );
          window.localStorage.setItem(
            "userId_AI",
            res.originalData.data.userId
          );
          window.localStorage.setItem("guestImei", imei);
          window.localStorage.setItem("loginType", 2);
        }
      });
    },
    // 判断当前游客和登录用户是否可以合并
    async isMergeable(guestSessionId, sessionId) {
      let params = {
        appId: window.localStorage.getItem("appId_AI"),
        guestSessionId,
        sessionId
      };
      let result = await Http.isMergeable(params).then(({ res }) => {
        console.log(res);
        if (res.code == "SUCCESS") {
          return res.originalData.data
        }
      }).catch(err => {
        console.log(err)
        Toast("网络异常");
        return false
      })
      return result;
    },
    // 确认合并游客对话记录
    async confirmMergeGuest() {
      let params = {
        appId: window.localStorage.getItem("appId_AI"),
        guestSessionId: vm.guestSessionId,
        sessionId: window.localStorage.getItem("sessionId_AI")
      }
      vm.loading = true
      await Http.mergeGuest(params).then(({ res }) => {
        console.log(res);
        if (res.code == "SUCCESS") {
          // 刷新
          // window.localStorage.removeItem("guestImei")
          window.location.reload();
        }
      }).catch(err => {
        console.log(err)
        Toast("网络异常");
      })
      vm.loading = false

    },
    // 确认不合并
    confirmNotMergeGuest() {
      // 刷新
      window.location.reload();
    },
    // 计时器   监听可视高度
    createIntervalTimer() {
      // 使用 requestAnimationFrame 优化性能，避免卡顿
      vm.visualViewportHeight_origin = window.visualViewport.height;

      let isRunning = true;

      const updateViewportHeight = () => {
        if (!isRunning) return;

        vm.visualViewportHeight_difference =
          window.innerHeight - Math.floor(window.visualViewport.height);

        // 使用 requestAnimationFrame 代替 setInterval
        vm.intervalTimer = requestAnimationFrame(updateViewportHeight);
      };

      // 开始监听
      updateViewportHeight();

      // 保存停止标志的引用，用于销毁时停止
      vm.stopViewportMonitoring = () => {
        isRunning = false;
      };
    },
    // 拦截a标签跳转
    interceptATag: function () {
      if (!window.aTagIntercept) {
        document.body.addEventListener("click", () => {
          // 兼容处理
          var target = event.target || event.srcElement;
          if (target.nodeName.toLocaleLowerCase() === "a") {
            console.log("当前点击的 a 标签: ", target);
            // 对捕获到的 a 标签进行处理，需要先禁止它的跳转行为
            if (event.preventDefault) {
              event.preventDefault();
            } else {
              window.event.returnValue = true;
            }
            // 处理完 a 标签的内容，重新触发跳转，根据原来 a 标签页 target 来判断是否需要新窗口打开
            let url = target.getAttribute("href");
            console.log(url);
            url = decodeURIComponent(url);
            let wechatShortLinkHead = "#小程序";
            if (url.indexOf(wechatShortLinkHead) != -1) {
              wx.miniProgram.navigateTo({
                url: `/pages/ShortLinkPage/ShortLinkPage?url=${encodeURIComponent(
                  url
                )}`,
              });
            } else {
              window.open(url);
            }
          }
        });

        window.aTagIntercept = true;
      }
    },
    // 点击inputContent
    clickInputContent: function () {
      if (!vm.isLogin) {
        vm.showLoginDialog = true;
        vm.$refs["textarea"].blur();
        return;
      }
      if (vm.isGuestOverLimit) {
        vm.openLoginDialog();
        vm.$refs["textarea"].blur();
        return;
      }
      if (!vm.textAreaDisabled) {
        vm.$refs["textarea"].focus();
      }
    },
    handleResize() {
      // 记录当前的isWideScreen
      let isWideScreen = vm.isWideScreen;
      vm.isWideScreen = window.innerWidth >= vm.wideWidth;
      if (isWideScreen == true && vm.isWideScreen == false) {
        vm.showLeftSideBar = false;
      }
      if (isWideScreen == false && vm.isWideScreen == true) {
        vm.showLeftSideBar = true;
      }
    },
    // 点击服务协议
    clickServiceAgreement: function () {
      window.open(process.env.VUE_APP_AGREEMENT_H5);
    },
    // 退出登录
    logout: function () {
      window.localStorage.removeItem("sessionId");
      window.localStorage.removeItem("sessionId_AI");
      window.localStorage.removeItem("userId_AI");
      window.localStorage.removeItem("loginType");
      // 跳转并刷新到根下的DesktopPage
      window.location.href = window.location.origin + "/#/DesktopPage";
      window.location.reload();
    },
    // 开始录音
    startRecord: async function () {
      vm.loading = true;
      // 重置计时器为60秒（倒计时）
      vm.second = 60;
      vm.dateTimeFormat = "01:00";
      // 设置转写文字更新回调，实时同步到inputContent
      vm.asrClient.onTranscriptUpdateCallback = (transcript) => {
        vm.inputContent = transcript;
        vm.textareaOnInput();
      };
      // 设置音量更新回调，实时更新音波图
      vm.asrClient.onVolumeUpdateCallback = (volume) => {
        vm.updateSoundWave(volume);
      };
      let result = await vm.asrClient.startRecording();
      vm.loading = false;
      console.log("开始录音的结果", result);
      if (result) {
        vm.isRecording = true;
        vm.startTimer();
      }
    },
    // 结束录音
    stopRecord: async function () {
      vm.isRecording = false;
      vm.asrClient.isEndedByUser = true;
      vm.stopTimer();
      // 重置音波图
      vm.resetSoundWave();
      // 先向ws发送停止的消息，等待ws返回final消息
      await vm.asrClient.stopRecording(() => {
        // handleFinalReceived执行后，执行后续业务逻辑
        console.log("停止录音流程完成，执行后续业务逻辑");
      });
    },
    // 更新音波图
    updateSoundWave: function (volume) {
      // 根据音量更新每个音波条的高度
      // 中间的条最高，两边依次递减
      const minHeight = 5;
      const maxHeight = 15;

      // 放大音量值，让较小的音量也能达到较高的显示效果
      // 使用幂函数让低音量更敏感，阈值降低
      let amplifiedVolume = Math.pow(volume, 0.5) * 1.8; // 开平方根放大，再乘以1.8倍
      amplifiedVolume = Math.min(1, amplifiedVolume); // 限制最大值为1

      const baseHeight = minHeight + amplifiedVolume * (maxHeight - minHeight);

      // 5个条的索引：0, 1, 2, 3, 4
      // 中间是索引2，设置不同的高度系数
      const heightFactors = [0.4, 0.7, 1.0, 0.7, 0.4]; // 中间最高，两边对称递减

      vm.soundWaveBars.forEach((bar, index) => {
        // 根据位置系数计算高度
        const factor = heightFactors[index];
        let height = minHeight + (baseHeight - minHeight) * factor;
        // 添加轻微的随机波动，让动画更自然
        const randomOffset = (Math.random() - 0.5) * 1.5;
        height = height + randomOffset;
        // 确保高度在范围内
        height = Math.max(minHeight, Math.min(maxHeight, height));
        bar.height = height;
      });
    },
    // 重置音波图
    resetSoundWave: function () {
      vm.soundWaveBars.forEach((bar) => {
        bar.height = 5;
      });
    },
    // 开始计时（倒计时）
    startTimer: function () {
      // 开始计时前 先调用一下停止计时 防止有未被销毁的定时器
      vm.stopTimer();
      vm.timer = setInterval(() => {
        vm.second = vm.second - 1;
        let minute = Math.floor(vm.second / 60);
        let second = vm.second % 60;
        let minuteFormat = minute > 9 ? minute : "0" + minute;
        let secondFormat = second > 9 ? second : "0" + second;
        vm.dateTimeFormat = minuteFormat + ":" + secondFormat;

        // 倒计时到0秒时停止录音
        if (vm.second <= 0) {
          vm.stopRecord();
          Toast("最长支持60秒录音");
        }
      }, 1000);
    },
    // 停止计时
    stopTimer: function () {
      if (vm.timer) {
        clearInterval(vm.timer);
        vm.timer = null;
      }
    },
    // 点击提示语
    clickSuggested: function (str) {
      vm.sendMessage(str);
    },
    // 点击了复制按钮
    clickCopyBtn: function (key) {
      copy(vm.$refs["answerText" + key][0].innerText);
      Toast("已复制");
    },
    // 用户点击 会话参数的picker
    onUserInputClickPicker: function (key) {
      vm.user_input_form[key].showPicker = true;
    },
    // 用户确认 会话参数的picker
    onUserInputPickerConfirm: function ($event, key) {
      console.log($event, key);
      vm.user_input_form[key].value = $event;
      setTimeout(() => {
        vm.user_input_form[key].showPicker = false;
      }, 100);
    },
    // 用户取消 会话参数的picker
    onUserInputPickerCancel: function (key) {
      console.log(key);
      setTimeout(() => {
        vm.user_input_form[key].showPicker = false;
      }, 100);
    },
    // 打开智能体详情popup
    openChatDetailPopup: function () {
      console.log(vm.currentChat_ai_app_code, vm.newChatInfo.ai_app_code);
      if (
        vm.newChatInfo &&
        vm.currentChat_ai_app_code != vm.newChatInfo.ai_app_code
      ) {
        // 点击的不是新对话，才能打开详情
        vm.showChatDetailPopup = true;
      }
    },
    // 点击markdown内容
    clickMarkdown: function (event) {
      // 获取被点击的元素
      const clickedElement = event.target;

      // 检查被点击的元素是否是图片
      if (clickedElement.tagName === "IMG") {
        // 如果点击的是图片，获取图片的src并预览
        const imageSrc = clickedElement.src;
        if (imageSrc) {
          previewImage(imageSrc);
        } else {
          console.log("图片 src 为空");
        }
      }
      // 如果点击的不是图片，不做任何操作
    },
    // 下载图片
    downloadImage: function (answer) {
      const match = answer.match(/!\[[^\]]*\]\((.*?)\)/);
      if (match) {
        let url = match[1];
        window.open(url);
      } else {
        console.log("未匹配到图片 URL");
      }
    },
    // 绘制亮啦ceo动画
    playCeoAnimation: async function (result) {
      // 直接插到最后一个
      let index = vm.chatContent.length - 1;
      for (let i of vm.ceoTextArr) {
        if (vm.isGenerating == false) {
          return;
        }
        await new Promise((resolve, reject) => {
          setTimeout(() => {
            let obj = {
              text: i,
              status: "loading",
            };
            vm.chatContent[index].ceoAnimateArr.push(obj);
            setTimeout(() => {
              let index2 = vm.chatContent[index].ceoAnimateArr.length - 1;
              vm.chatContent[index].ceoAnimateArr[index2].status = "loadover";
              vm.scrollToBottom(false);
              resolve();
            }, 1000);
          }, 500);
        });
      }
      vm.chatContent[index].finishSpecialThink = true;
      vm.ceoAnimationPlayOver = true;
      vm.onMessage(result);
      if (vm.ceoAnimationMessageEnd) {
        vm.messageEnd(result);
      }
    },
    // 播放器callback方法
    playerCallback: function (str, detail) {
      console.log(str, detail);
      switch (str) {
        // 播放事件
        case "play":
          vm.playingContentIndex = vm.currentPlayingContentIndex;
          break;
        case "timeupdate":
          vm.playingContentIndex = vm.currentPlayingContentIndex;
          break;
        case "paused":
          // 不再对暂停做特殊处理了
          // vm.playingContentIndex = -1;
          // vm.currentPlayingContentIndex = -1;
          break;
        case "ended":
          vm.playingContentIndex = -1;
          vm.currentPlayingContentIndex = -1;
          break;
        // 当发现错误时，不再继续播放了
        case "error":
          vm.clickStopPlayBtn();
          vm.playingContentIndex = -1;
          vm.currentPlayingContentIndex = -1;
          vm.$toast("播放异常");
          break;
        case "fetch_error":
          vm.clickStopPlayBtn();
          vm.playingContentIndex = -1;
          vm.currentPlayingContentIndex = -1;
          vm.$toast("网络异常");
          break;
        case "destroy":
          // 销毁
          vm.playingContentIndex = -1;
          vm.currentPlayingContentIndex = -1;
          break;
      }
    },
    visibilitychange: function () {
      if (document.hidden) {
        if (vm.audioPlayer) {
          vm.clickStopPlayBtn();
        }
      }
    },
    // 点击停止播放语音
    clickStopPlayBtn: function () {
      if (vm.audioPlayer) {
        vm.audioPlayer.destroy();
        vm.audioPlayer = null;
      }
    },
    // 点击播放语音
    clickPlayBtn: async function (index) {
      console.log("点击播放语音");
      if (vm.audioPlayer) {
        vm.clickStopPlayBtn();
      }
      vm.loading = true;
      let result = await vm.getTTSLimit();
      if (result.code == "SUCCESS") {
        let currentTextLength = vm.chatContent[index].answer.length;
        if (currentTextLength > result.remainToken) {
          vm.$toast(
            `当前文本长度${currentTextLength},剩余语音播放额度${result.remainToken},无法播放`
          );
          vm.loading = false;
          return;
        }
        vm.audioPlayer = new AudioPlayer(vm.playerCallback, index);
        console.log(vm.audioPlayer);
        const au = vm.audioPlayer.audio;
        const ctx = vm.audioPlayer.audioContext;
        /* ---------- 手势栈内：解锁 + 静音占坑 ---------- */
        await ctx.resume(); // 解锁 Web‑Audio
        au.muted = true; // 静音
        try {
          au.play();
        } catch (_) { } // 在手势中 play，拿到播放许可
        const onCanPlay = () => {
          au.muted = false; // 真正发声
          au.removeEventListener("canplay", onCanPlay);
        };
        au.addEventListener("canplay", onCanPlay);
        vm.currentPlayingContentIndex = index;
        vm.audioPlayer.loadAudio(
          vm.currentChat_ai_app_code,
          vm.$refs["answerText" + index][0].innerText,
          index
        );
      }
      // 达到播放上限  关闭自动播放
      else if (result.code == "TTS_LIMIT") {
        vm.$toast("今日语音播放额度已用完，请明日再试");
        await vm.switchAutoTTS(0);
      }
      vm.loading = false;
    },
    // 执行自动播放语音
    autoPlay: async function (index) {
      console.log("执行了自动播放语音");
      vm.currentPlayingContentIndex = index;
      let result = await vm.getTTSLimit();
      if (result.code == "SUCCESS") {
        vm.audioPlayer.autoLoadAudio(
          vm.currentChat_ai_app_code,
          vm.currentChat_conversation_id,
          vm.chatContent[index].id
        );
      }
      // 达到播放上限  关闭自动播放
      else if (result.code == "TTS_LIMIT") {
        vm.$toast("今日语音播放额度已用完，请明日再试");
        vm.switchAutoTTS(0);
      }
    },
    // 获取提示语
    getSuggested: async function (requestId) {
      let params = {
        ai_app_code: vm.currentChat_ai_app_code,
        message_id: vm.chatContent[vm.chatContent.length - 1].id,
      };
      await Http.getSuggested(params)
        .then(({ res }) => {
          console.log(res);
          if (res.originalData.code == "SUCCESS") {
            // 返回的时候 如果发现此时正在生成中，那么直接弃掉这个结果
            if (vm.isGenerating) {
              return;
            }
            // 如果发现当前的requestId和传入的requestId不一致，则不进行处理
            if (vm.requestId_getSuggested != requestId) {
              return;
            }
            vm.suggestedData = res.originalData.data.data;
            // 只有当返回了结果，并且结果大于0时，才进行滚动
            if (vm.suggestedData.length > 0) {
              vm.scrollToBottom(true);
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 移动滚动条到底部  conversationList
    // force 是否是强制移动
    scrollToBottom: function (isForce) {
      // console.log("执行scrollToBottom", vm.isAutoScroll, isForce);
      // 如果当前不是自动滚动模式 并且 本次滚动不是强制滚动
      if (!vm.isAutoScroll && !isForce) {
        // 直接返回
        return;
      }
      // 如果是强制滚动
      if (isForce) {
        vm.$nextTick(() => {
          vm.$refs["conversationContent"].scrollIntoView({
            behavior: "smooth",
            block: "end", // 重点：让它对齐到底部
          });
        });
      } else {
        if (vm.waitScroll) {
          return;
        }
        vm.waitScroll = true;
        // 500毫秒后执行滚动
        setTimeout(() => {
          vm.$refs["conversationContent"].scrollIntoView({
            behavior: "smooth",
            block: "end", // 重点：让它对齐到底部
          });
          vm.waitScroll = false;
        }, 500);
      }
    },
    // 获取举报类型
    getComplaintTypes: async function () {
      await Http.complaintTypes({})
        .then(({ res }) => {
          if (res.code == "SUCCESS") {
            vm.reportTypeList = res.originalData.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击举报类型
    clickReportType: function (item) {
      console.log(item);
      vm.currentReportType = item;
    },
    // 提交举报
    confirmReport: async function () {
      console.log("提交举报");
      if (vm.currentReportType == null) {
        vm.$toast("请选择举报类型");
        return;
      }
      if (vm.reportContent.trim() == "") {
        vm.$toast("请填写举报原因");
        return;
      }
      vm.loading = true;
      let params = {
        complaintType: vm.currentReportType,
        complaintContent: vm.reportContent,
        ai_app_code: vm.currentChatPopoverItem.ai_app_code,
      };
      await Http.complaintAdd(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            vm.showReportDialog = false;
            vm.$toast("举报已提交");
            // 举报成功后,将已选择的举报类型置为空
            vm.currentReportType = null;
            // 举报成功后,将举报原因置为空
            vm.reportContent = "";
          } else {
            vm.$toast(res.originalData.msg || "提交失败");
          }
        })
        .catch((err) => {
          console.log(err);
          vm.$toast("网络异常");
        });
      vm.loading = false;
    },
    // 清除上下文
    clearContext: async function () {
      console.log("清除上下文");
      let params = {
        ai_app_code: vm.currentChat_ai_app_code,
      };
      await Http.cleanConversationText(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            vm.currentChat_conversation_id = null;
            vm.showClearContextDialog = false;
            vm.showChatDetailPopup = false;
            vm.updateHistoryListConversationId(
              vm.currentChat_ai_app_code,
              null
            );

            vm.$toast("清除成功");
            // 重新加载一遍对话  其实就是强制切换对话
            vm.switchChat();
          }
        })
        .catch((err) => {
          console.log(err);
          vm.$toast("网络异常");
        });
    },
    // 编辑对话名称
    editChatName: function () {
      console.log("编辑对话名称");
    },
    // 点击置顶、取消置顶
    clickSetTop: async function () {
      let value = vm.currentChatPopoverItem;
      let params = {
        ai_app_code: value.ai_app_code,
      };
      if (vm.newChatInfo && value.ai_app_code == vm.newChatInfo.ai_app_code) {
        params.conversation_id = value.conversation_id;
      }
      // 如果当前是置顶状态
      if (value.topUpFlag) {
        // 取消置顶操作
        params.operate = "cancel";
      } else {
        // 置顶操作
        params.operate = "up";
      }
      vm.loading = true;
      await Http.conversationSetTop(params)
        .then(async ({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            value.topUpFlag ? vm.$toast("取消置顶成功") : vm.$toast("置顶成功");
            await vm.getHistoryMessageList();
          }
        })
        .catch((err) => {
          console.log(err);
          vm.$toast("网络异常");
        });
      vm.loading = false;
    },
    // 点击编辑
    clickEdit: function () {
      console.log("点击编辑");
      vm.showEditChatNameDialog = true;
      vm.editChatName_inputValue = vm.currentChatPopoverItem.name;
    },
    // 点击确认编辑
    editChatName: async function () {
      if (vm.editChatName_inputValue == "") {
        vm.$toast("请输入内容");
        return;
      }
      let params = {
        ai_app_code: vm.currentChatPopoverItem.ai_app_code,
        conversation_id: vm.currentChatPopoverItem.conversation_id,
        name: vm.editChatName_inputValue,
      };
      vm.loading = true;
      await Http.conversationRename(params)
        .then(async ({ res }) => {
          if (res.code == "SUCCESS") {
            vm.$toast("编辑成功");
            vm.showEditChatNameDialog = false;
            await vm.getHistoryMessageList();
          }
        })
        .catch((err) => {
          console.log(err);
          vm.$toast("网络异常");
        });
      vm.loading = false;
    },
    // 点击分享
    clickShare: function () {
      console.log("点击分享");
      // 获取当前URL
      let url = window.location.href;
      // 截取问号前面的部分
      if (url.includes("?")) {
        url = url.split("?")[0];
      }
      url = url + `?share_ai_app_code=${vm.currentChatPopoverItem.ai_app_code}`;
      // 创建一个临时的textarea元素
      const textarea = document.createElement("textarea");
      textarea.value = url;
      // 将元素添加到DOM中
      document.body.appendChild(textarea);
      // 选中文本
      textarea.select();
      // 执行复制命令
      document.execCommand("copy");
      // 从DOM中移除临时元素
      document.body.removeChild(textarea);

      // 提示用户复制成功
      vm.$toast("链接已复制到剪贴板");
    },
    // 点击分享  来自详情页
    clickShare_fromDetail: function () {
      console.log("点击分享");
      // 获取当前URL
      let url = window.location.href;
      // 截取问号前面的部分
      if (url.includes("?")) {
        url = url.split("?")[0];
      }
      url = url + `?share_ai_app_code=${vm.currentChat_ai_app_code}`;
      // 创建一个临时的textarea元素
      const textarea = document.createElement("textarea");
      textarea.value = url;
      // 将元素添加到DOM中
      document.body.appendChild(textarea);
      // 选中文本
      textarea.select();
      // 执行复制命令
      document.execCommand("copy");
      // 从DOM中移除临时元素
      document.body.removeChild(textarea);

      // 提示用户复制成功
      vm.$toast("链接已复制到剪贴板");
    },
    // 点击举报
    clickReport: function () {
      console.log("点击举报");
      vm.showReportDialog = true;
    },
    // 点击删除
    clickDelete: function () {
      console.log("点击删除");
      vm.showDeleteChatDialog = true;
    },
    // 确认删除
    confirmDelete: async function () {
      console.log("确认删除");
      let params = {
        conversation_id: vm.currentChatPopoverItem.conversation_id,
        ai_app_code: vm.currentChatPopoverItem.ai_app_code,
      };
      vm.loading = true;
      await Http.deleteMessage(params)
        .then(async ({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            vm.$toast("删除成功");
            vm.showDeleteChatDialog = false;
            await vm.getHistoryMessageList();
            await vm.getFindList();
            // 这里要判断一下 如果当前会话是删除的会话 则切换到新对话
            if (
              vm.currentChat_conversation_id ==
              vm.currentChatPopoverItem.conversation_id
            ) {
              console.log("切换到新对话");
              await vm.clickOpenNewChat();
            }
          }
        })
        .catch((err) => {
          console.log(err);
          vm.$toast("网络异常");
        });
      vm.loading = false;
    },
    confirmDelete_fromDetail: async function () {
      console.log("确认删除");
      let params = {
        conversation_id: vm.currentChat_conversation_id,
        ai_app_code: vm.currentChat_ai_app_code,
      };
      vm.loading = true;
      await Http.deleteMessage(params)
        .then(async ({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            vm.$toast("删除成功");
            vm.showDeleteChatDialog_fromDetail = false;
            vm.showChatDetailPopup = false;
            await vm.getHistoryMessageList();
            await vm.getFindList();
            await vm.clickOpenNewChat();
          }
        })
        .catch((err) => {
          console.log(err);
          vm.$toast("网络异常");
        });
      vm.loading = false;
    },
    // 登录后需要调用的接口
    loginAfter: async function () {
      // 获取会员信息
      await vm.getUserVipInfo();
      // 先获取历史对话列表
      await vm.getHistoryMessageList();
      // 再获取发现列表
      await vm.getFindList();
      // 再获取今日会话次数
      await vm.getConversationCount();
      // 再获取引导列表
      await vm.getGuides();
      // 获取新对话
      await vm.getNewChat();
      // 获取举报类型
      await vm.getComplaintTypes();
      // 尝试从路由中获取对话
      if (vm.$route.query.share_ai_app_code) {
        // 如果路由中存在share_ai_app_code，则尝试切换对话
        vm.currentChat_ai_app_code = vm.$route.query.share_ai_app_code;
        // 如果当前没有conversation_id，则查询是否存在会话
        if (!vm.currentChat_conversation_id) {
          let result = await vm.findConversation();
          // 这个智能体是已经被添加到对话列表中的
          if (result && result.conversation_id) {
            vm.currentChat_conversation_id = result.conversation_id;
            // 直接切换过去
            vm.loading = true;
            await vm.clickHistoryChatItem(
              {
                ai_app_code: vm.currentChat_ai_app_code,
                conversation_id: vm.currentChat_conversation_id,
              },
              true
            );
            vm.loading = false;
          } else {
            console.log(
              "没查到conversation_id  代表着这是一个从未添加过的智能体"
            );
            // 没查到conversation_id  代表着这是一个从未添加过的智能体
            // 添加智能体 并且切换过去
            vm.loading = true;
            await vm.addAgentToHistoryChatList({
              ai_app_code: vm.currentChat_ai_app_code,
            });
            vm.loading = false;
          }
        }
      }
      // 否则的话，默认是新对话
      else {
        vm.currentChat_ai_app_code = vm.newChatInfo.ai_app_code;
        vm.currentChat_conversation_id = null;
        vm.currentChat = vm.newChatInfo;
        await vm.switchChat();
      }
    },
    // 获取会员信息
    getUserVipInfo: async function () {
      let params = {
        bizSession: localStorage.getItem("sessionId_AI"),
      };
      await Http.getUserVipInfo(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            vm.isVip = res.originalData.data.status == "1" ? true : false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // textarea自动拉伸
    textareaOnInput: function () {
      let textarea = vm.$refs["textarea"];
      textarea.style.height = "auto";
      textarea.style.height = textarea.scrollHeight + "px";
    },
    // textarea重新计算高度
    textareaResize: function () {
      vm.$nextTick(() => {
        let textarea = vm.$refs["textarea"];
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      });
    },
    // 打开登录选项
    openLoginPopover: function ($event) {
      console.log($event);
      vm.showLoginPopover = true;
      vm.loginPopoverTriggerEvent = $event;
    },
    // 打开对话的选项框
    openChatPopover: function ($event, value) {
      console.log($event, value);
      vm.showChatPopover = true;
      vm.showMoreChatPopover = false;

      // 记录当前打开的对话气泡
      vm.currentChatPopoverItem = value;
      // 生成气泡的选项
      vm.chatPopoverOptions = [];
      // 是否可以顶置&是否可以取消顶置
      if (value.topUpFlag) {
        vm.chatPopoverOptions.push("setUntop");
      } else {
        vm.chatPopoverOptions.push("setTop");
      }
      // 是否可以编辑
      if (value.type == "normal") {
        vm.chatPopoverOptions.push("edit");
      }
      // 是否可以分享
      if (value.type == "operate" || value.type == "default") {
        vm.chatPopoverOptions.push("share");
        vm.chatPopoverOptions.push("report");
      }
      // 是否可以删除
      if (value.type != "default") {
        vm.chatPopoverOptions.push("delete");
      }
      // 打开chatPopover
      vm.chatPopoverTriggerEvent = $event;
    },
    // 打开对话的选项框 --来自更多对话框的弹窗
    openChatPopover2: function ($event, value) {
      console.log($event, value);
      vm.showChatPopover = true;
      vm.showMoreChatPopover = true;
      vm.chatPopoverTriggerEvent = $event;
    },
    // 打开更多对话的弹窗
    openMoreChatPopover: function ($event, value) {
      vm.showMoreChatPopover = true;
      vm.showChatPopover = false;
      vm.moreChatPopoverTriggerEvent = $event;
    },
    // 关闭所有对话框
    closeAllPopover: function () {
      vm.showChatPopover = false;
      vm.showMoreChatPopover = false;
      vm.showLoginPopover = false;
    },
    // 点击右上角登录按钮
    clickLoginBtn: function () {
      vm.openLoginDialog();
    },
    // 手机号脱敏
    maskPhone: function (phone) {
      return phone.replace(/^(\d{3})\d{4}(\d{4})$/, "$1****$2");
    },
    //  触发 弹出登录框
    openLoginDialog: function () {
      vm.showLoginDialog = true;
    },
    // 点击获取验证码
    clickGetCaptcha: async function () {
      if (vm.inputPhoneNumber.length < 11) {
        vm.$toast("请输入正确的手机号");
        return;
      }
      if (vm.hasAgreeAgreement == false) {
        vm.showWarmHintDialog = true;
        return;
      }
      vm.loading = true;
      let params = {
        system: "lzpc",
        phone: vm.inputPhoneNumber,
      };
      await Http.getCaptcha(params)
        .then(({ res }) => {
          vm.loading = false;
          console.log(res);
          if (res.originalData.code == "SUCCESS") {
            vm.$toast("发送成功");
            vm.loginDialogType = 2;
            vm.loginCountDown = 60;
            vm.setLoginCountDown();
          } else {
            vm.$toast(res.originalData.msg || "网络异常");
          }
        })
        .catch((err) => {
          vm.loading = false;
          console.log(err);
          vm.$toast("网络异常");
        });
    },
    // 设置验证码倒计时
    setLoginCountDown: function () {
      if (vm.loginCountDownTimer) {
        clearInterval(vm.loginCountDownTimer);
        vm.loginCountDownTimer = null;
      }
      vm.loginCountDownTimer = setInterval(() => {
        vm.loginCountDown = vm.loginCountDown - 1;
        if (vm.loginCountDown <= -1) {
          clearInterval(vm.loginCountDownTimer);
          vm.loginCountDownTimer = null;
        }
      }, 1000);
    },
    // 登录验证码 输入事件
    loginCaptchaOnInput: function (e) {
      console.log(vm.loginCaptchaStr);
      let arr = vm.loginCaptchaStr.split("");
      for (let i of vm.loginCaptchaArr) {
        i.focus = false;
        i.value = "";
        i.error = false;
      }
      for (let i in arr) {
        vm.loginCaptchaArr[i].value = arr[i];
      }
      if (vm.loginCaptchaStr.length === 4) {
        vm.loginCaptchaArr[3].focus = true;
        // 位数为4位时，调接口
        vm.SmsLogin(vm.loginCaptchaStr);
      } else {
        vm.loginCaptchaArr[vm.loginCaptchaStr.length].focus = true;
      }
    },
    // 登录验证码 聚焦事件
    loginCaptchaOnFocus: function () {
      for (let i of vm.loginCaptchaArr) {
        i.focus = false;
      }
      if (vm.loginCaptchaStr.length === 4) {
        vm.loginCaptchaArr[3].focus = true;
      } else {
        vm.loginCaptchaArr[vm.loginCaptchaStr.length].focus = true;
      }
    },
    // 登录验证码  失焦事件
    loginCaptchaOnBlur: function () {
      for (let i of vm.loginCaptchaArr) {
        i.focus = false;
      }
    },
    // 手机号登录
    SmsLogin: async function (smsCode) {
      let params = {
        system: "lzpc",
        phone: vm.inputPhoneNumber,
        smsCode: smsCode,
        guestImei: window.localStorage.getItem("guestImei"),
      };
      vm.loading = true;
      let guestSessionId = window.localStorage.getItem("sessionId_AI") || null;
      await Http.SmsLogin(params)
        .then(async ({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS" && res.originalData.code == "SUCCESS") {
            vm.isLogin = true;
            vm.loginType = 1;
            vm.isGuestOverLimit = false;
            vm.showLoginDialog = false;
            // 把userId和sessionId写入本地
            window.localStorage.setItem(
              "userId_AI",
              res.originalData.data.userId
            );
            window.localStorage.setItem(
              "sessionId_AI",
              res.originalData.data.sessionId
            );
            window.localStorage.setItem("loginType", 1);
            // 把用户手机号写入本地
            window.localStorage.setItem("userPhoneNumber", vm.inputPhoneNumber);
            vm.inputPhoneNumber = vm.inputPhoneNumber.slice(-4);
            // 登录成功后，这里要看一下 是否需要合并
            // 存在游客sessionId 且当前开启了游客模式
            if (guestSessionId && vm.systemOpenGuestMode) {
              console.log("存在游客sessionId 且当前开启了游客模式")
              console.log(guestSessionId, res.originalData.data.sessionId)
              let result = await vm.isMergeable(guestSessionId, res.originalData.data.sessionId);
              console.log(result);
              console.log(result.status)
              // 返回了结果
              if (result) {
                // 可以合并
                if (result.status == true) {
                  // 弹窗
                  vm.showMergeGuestDialog = true
                  vm.guestSessionId = guestSessionId
                }
                else {
                  // 不能合并  直接大刷新
                  window.location.reload();
                }
              }
              // 结果异常  直接大刷新
              else {
                window.location.reload();
              }
            }
            // 不存在 不需要合并  直接大刷新
            else {
              window.location.reload();
            }
          } else {
            for (let i of vm.loginCaptchaArr) {
              i.error = true;
            }
            vm.$toast(res.originalData.msg || "网络异常");
          }
        })
        .catch((err) => {
          console.log(err);
        });
      vm.loading = false;
    },
    // 获取发现列表
    getFindList: async function () {
      let params = {
        system: "lzpc",
      };
      await Http.getFindList(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            // 要看一下historyList是否存在findlist中的ai_app_code
            // 如果存在，要将findlist中的值给剔除
            let findListData = res.originalData.data;
            // 如果historyList不为空，则过滤掉已经存在于historyList中的ai_app_code
            if (vm.historyList && vm.historyList.length > 0) {
              // 获取historyList中所有的ai_app_code
              const historyAppCodes = vm.historyList.map(
                (item) => item.ai_app_code
              );
              // 过滤findListData，剔除已存在于historyList中的项
              findListData = findListData.filter(
                (item) => !historyAppCodes.includes(item.ai_app_code)
              );
            }
            vm.findList = findListData;
            vm.findListForSideBar = findListData.slice(0, vm.findListShowCount);
            vm.moreChatList = findListData.slice(vm.findListShowCount);
          } else {
            vm.$toast(res.originalData.msg || "网络异常");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取历史对话列表
    getHistoryMessageList: async function () {
      let params = {
        pageNum: vm.pageNum,
        pageSize: vm.pageSize,
      };
      await Http.getHistoryMessageList(params)
        .then(async ({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            vm.historyList = res.originalData.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取今日会话次数
    getConversationCount: async function () {
      let params = {};
      await Http.getConversationCount(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            vm.currentCount = res.originalData.data.currentCount;
            vm.totalCount = vm.loginType == 2 ? res.originalData.data.guestTotalCount : res.originalData.data.totalCount;
            vm.currentTokenCount = res.originalData.data.currentTokenCount;
            vm.totalTokenCount = res.originalData.data.totalTokenCount;
            vm.vipTotalCount = res.originalData.data.vipTotalCount;
          }
        })
        .catch((err) => {
          console.log(err);
          vm.$toast("网络异常");
        });
    },
    // 获取引导列表
    getGuides: async function () {
      let params = {
        system: "lzpc",
      };
      await Http.getGuides(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            vm.guideList = res.originalData.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击发现项
    clickFindItem: async function (value) {
      if (!vm.isWideScreen) {
        vm.showLeftSideBar = false;
      }
      if (!vm.isLogin) {
        vm.showLoginDialog = true;
        return;
      }
      vm.loading = true;
      await vm.addAgentToHistoryChatList(value);
      vm.loading = false;
    },
    // 获取会话名称
    getConversationName: async function () {
      let params = {
        conversation_id: vm.currentChat_conversation_id,
        ai_app_code: vm.currentChat_ai_app_code,
      };
      await Http.getConversationName(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            // 兜底
            if (res.originalData.data && res.originalData.data.name) {
              let name = res.originalData.data.name;
              vm.currentChat.name = name;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          vm.$toast("网络异常");
        });
    },
    // 将智能体添加到历史对话列表
    addAgentToHistoryChatList: async function (value) {
      let params = {
        ai_app_code: value.ai_app_code,
      };
      vm.loading = true;
      await Http.addAgent(params)
        .then(async ({ res }) => {
          if (res.code == "SUCCESS") {
            await vm.getHistoryMessageList();
            await vm.getFindList();
            vm.currentChat_ai_app_code = value.ai_app_code;
            vm.currentChat_conversation_id = null;
            await vm.switchChat();
          }
        })
        .catch((err) => {
          console.log(err);
        });
      vm.loading = false;
    },
    // 点击引导项
    clickGuideItem: async function (value) {
      if (!vm.isLogin) {
        vm.showLoginDialog = true;
        return;
      }
      let params = {
        ai_app_code: value.agentCode,
      };
      vm.loading = true;
      await Http.addAgent(params)
        .then(async ({ res }) => {
          if (res.code == "SUCCESS") {
            await vm.getHistoryMessageList();
            await vm.getFindList();
            vm.currentChat_ai_app_code = value.agentCode;
            // 如果当前没有conversation_id，则查询是否存在会话
            let result = await vm.findConversation();
            if (result && result.conversation_id) {
              vm.currentChat_conversation_id = result.conversation_id;
            } else {
              vm.currentChat_conversation_id = null;
            }
            await vm.switchChat();
          }
        })
        .catch((err) => {
          console.log(err);
        });
      vm.loading = false;
    },
    // 点击历史会话项   jumpCheck=> 跳过检查
    clickHistoryChatItem: async function (value, jumpCheck) {
      if (!vm.isWideScreen) {
        vm.showLeftSideBar = false;
      }
      if (!vm.isLogin) {
        vm.showLoginDialog = true;
        return;
      }
      vm.currentChat_ai_app_code = value.ai_app_code;
      if (vm.newChatInfo && value.ai_app_code != vm.newChatInfo.ai_app_code) {
        // 这里还是要查一下   有没有最新的conversation_id
        if (jumpCheck) {
          vm.currentChat_conversation_id = value.conversation_id;
        } else {
          let result = await vm.findConversation();
          if (result && result.conversation_id) {
            vm.currentChat_conversation_id = result.conversation_id;
          } else {
            vm.currentChat_conversation_id = value.conversation_id;
          }
        }
      } else {
        vm.currentChat_conversation_id = value.conversation_id;
      }

      vm.loading = true;
      await vm.switchChat();
      vm.loading = false;
    },
    // 获取新对话和默认对话
    getNewChat: async function () {
      await Http.getNewChat({})
        .then(({ res }) => {
          if (res.code == "SUCCESS") {
            if (res.originalData.data) {
              // 拿到新对话数据
              if (res.originalData.data.normal) {
                vm.newChatInfo = res.originalData.data.normal;
                vm.$store.commit("newChatInfo", res.originalData.data.normal);
              }
              // 拿到默认对话数据
              if (res.originalData.data.default) {
                vm.defaultChatInfo = res.originalData.data.default;
                vm.$store.commit(
                  "defaultChatInfo",
                  res.originalData.data.default
                );
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询智能体信息
    getAgentInfo: async function () {
      let params = {
        ai_app_code: vm.currentChat_ai_app_code,
        system: localStorage.getItem("channelCode_AI"),
      };
      await Http.getAgentInfo(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            // 应用被下架
            if (!res.originalData.data) {
              vm.$toast("应用已下架");
            } else {
              vm.currentChat = res.originalData.data;
              let url = window.location.href;
              if (url.indexOf("?") != -1) {
                url = url + "&";
              } else {
                url = url + "?";
              }
              let newChatInfo = vm.$store.getters.newChatInfo;
              let defaultChatInfo = vm.$store.getters.defaultChatInfo;
              // 如果既有新对话，又有默认对话
              if (newChatInfo && defaultChatInfo) {
                // 如果当前的code是新对话   那么分享默认对话
                if (vm.currentChat_ai_app_code == newChatInfo.ai_app_code) {
                  url =
                    url + `share_ai_app_code=${defaultChatInfo.ai_app_code}`;
                  window.history.replaceState(null, document.title, url);
                }
                // 否则  分享的是当前code的对话
                else {
                  url = url + `share_ai_app_code=${vm.currentChat.ai_app_code}`;
                  window.history.replaceState(null, document.title, url);
                }
              }
              // 只有新对话
              else if (newChatInfo) {
                // 什么都不用做
              }
              // 只有默认对话
              else if (defaultChatInfo) {
                // 分享当前code的对话
                url = url + `share_ai_app_code=${vm.currentChat.ai_app_code}`;
                window.history.replaceState(null, document.title, url);
              }
              // 既没有新对话 有没有默认对话
              else {
                // 什么都不用做
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询是否自动播放
    getAutoTTSInfo: async function () {
      let params = {
        conversationId: vm.currentChat_conversation_id,
        ai_app_code: vm.currentChat_ai_app_code,
      };
      await Http.getAutoTTSInfo(params)
        .then(({ res }) => {
          console.log(res);
          if (res.originalData.code == "SUCCESS") {
            vm.isAutoPlayVoice = res.originalData.data && !vm.hideTTSBtn;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 查询tts token数量
    getTTSLimit: async function () {
      let params = {};
      let result = await Http.getTTSLimit(params)
        .then(({ res }) => {
          console.log(res);
          if (res.originalData.code == "SUCCESS") {
            return {
              code: "SUCCESS",
              remainToken: res.originalData.data.remainToken,
            };
          } else if (res.originalData.code == "TTS_LIMIT") {
            return {
              code: "TTS_LIMIT",
            };
          } else {
            vm.$toast(res.originalData.msg);
            return false;
          }
        })
        .catch((err) => {
          vm.$toast("网络异常");
          return false;
        });
      return result;
    },
    // 点击切换自动播放
    clickSwitchAutoTTS: async function () {
      // 只有在将要打开自动播放的时候  才进行判断
      if (vm.isAutoPlayVoice == false) {
        vm.loading = true;
        let result = await vm.getTTSLimit();
        if (result.code == "SUCCESS") {
          await vm.switchAutoTTS();
        }
        // 达到播放上限  关闭自动播放
        else if (result.code == "TTS_LIMIT") {
          vm.$toast("今日语音播放额度已用完，请明日再试");
        }
        vm.loading = false;
      } else {
        vm.loading = true;
        await vm.switchAutoTTS();
        vm.loading = false;
      }
    },
    // 打开/关闭 自动播放
    switchAutoTTS: async function (state) {
      let params = {
        conversationId: vm.currentChat_conversation_id,
        ai_app_code: vm.currentChat_ai_app_code,
      };
      if (state !== undefined) {
        params.state = state;
      } else if (vm.isAutoPlayVoice) {
        params.state = 0;
      } else {
        params.state = 1;
      }
      console.log(params);
      await Http.switchAutoTTS(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS" && res.originalData.code == "SUCCESS") {
            if (params.state === 0) {
              vm.isAutoPlayVoice = false;
              if (state === undefined) {
                vm.$toast("已关闭语音自动播放功能");
              }
              if (vm.audioPlayer) {
                vm.clickStopPlayBtn();
              }
            } else {
              vm.isAutoPlayVoice = true;
              if (state === undefined) {
                vm.$toast("已开启语音自动播放功能");
              }
            }
          } else {
            vm.$toast(res.originalData.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取开场白
    getPrologue: async function () {
      let params = {
        ai_app_code: vm.currentChat_ai_app_code,
      };
      await Http.getPrologue(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS" && res.originalData.code == "SUCCESS") {
            vm.prologue = res.originalData.data.opening_statement;
            vm.prologueList = res.originalData.data.suggested_questions;
            //获取到配置的文件可上传类型，文件可上传大小
            if (res.originalData.data.file_upload.allowed_file_types) {
              vm.$store.commit(
                "allowedFileTypes",
                res.originalData.data.file_upload.allowed_file_types
              );
            }
            if (res.originalData.data.file_upload.fileUploadConfig) {
              vm.$store.commit(
                "fileUploadConfig",
                res.originalData.data.file_upload.fileUploadConfig
              );
            }
            //设置文件可上传数量
            if (res.originalData.data.file_upload.number_limits) {
              vm.$store.commit(
                "maxUploadCnt",
                res.originalData.data.file_upload.number_limits
              );
              vm.maxUploadCnt = res.originalData.data.file_upload.number_limits;
            }
            //是否允许文件上传
            if (
              res.originalData.data.file_upload.enabled &&
              res.originalData.data.file_upload.number_limits > 0
            ) {
              vm.showFileUpload = true;
            }
            // 用户inputs输入数据
            if (res.originalData.data.user_input_form) {
              let user_input_form = [];
              for (let i of res.originalData.data.user_input_form) {
                if (i["text-input"] && i["text-input"].hide != true) {
                  let obj = i["text-input"];
                  obj.type == "text-input";
                  obj.value = null;
                  user_input_form.push(obj);
                } else if (i["paragraph"] && i["paragraph"].hide != true) {
                  let obj = i["paragraph"];
                  obj.type = "paragraph";
                  obj.value = obj.default || "";
                  user_input_form.push(obj);
                } else if (i["select"] && i["select"].hide != true) {
                  let obj = i["select"];
                  obj.type == "select";
                  user_input_form.push(obj);
                  obj.showPicker = false;
                  obj.value = null;
                }
              }
              vm.user_input_form = user_input_form;
            }
          } else {
            Toast("网络异常");
          }
        })
        .catch((err) => {
          console.log(err);
          Toast("网络异常");
        });
    },
    // 查询会话详情 获取当前会话额度&inputs参数
    getChatDetail: async function () {
      let params = {
        ai_app_code: vm.currentChat_ai_app_code,
      };
      await Http.getChatDetail(params)
        .then(({ res }) => {
          console.log(res, "getChatDetail");
          if (res.code == "SUCCESS") {
            vm.chatDetail = res.originalData.data;
            if (vm.chatDetail.inputs) {
              let obj = JSON.parse(vm.chatDetail.inputs);
              // 回显用户上次输入的数据
              for (let i of vm.user_input_form) {
                if (obj[i.variable]) {
                  i.value = obj[i.variable];
                }
              }
            }
            // 如果当前用户不是会员 且智能体为会员专属
            if (vm.isVip == false && vm.chatDetail.vipOnly == 1) {
              vm.showInputBottomHint = true;
              vm.inputBottomHintType = 2;
            }
          }
        })
        .catch((err) => { });
    },
    // 获取历史会话详情
    getHistoryMessageDetail: async function () {
      // 如果是新对话，不调接口
      if (vm.currentChat_conversation_id == null) {
        vm.chatContentHasMore = false;
        return;
      }
      let params = {
        conversation_id: vm.currentChat_conversation_id,
        ai_app_code: vm.currentChat_ai_app_code,
      };
      if (vm.chatContent.length > 0) {
        params.first_id = vm.chatContent[0].id;
      }
      await Http.getHistoryMessageDetail(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            if (res.originalData.data.has_more) {
              vm.chatContentHasMore = true;
            } else {
              vm.chatContentHasMore = false;
            }
            vm.chatContentLoading = false;
            // dify接口改了
            let data = cloneDeep(res.originalData.data.data);
            for (let i of data) {
              // 匹配亮啦ceo
              if (vm.currentChat.extraCode == "llceo") {
                i.finishSpecialThink = true;
                i.isSpecialThink = true;
                i.ceoAnimateArr = [];
                i.isFold = true;
                for (let j of vm.ceoTextArr) {
                  i.ceoAnimateArr.push({
                    text: j,
                    status: "loadover",
                  });
                }
              }
              // 如果找到了深度思考的抬头和结束符
              if (
                i.answer.indexOf(deepSeekHead) != -1 &&
                i.answer.indexOf(deepSeekFooter) != -1
              ) {
                i.allAnswer = i.answer;
                i.isDeepSeek = true;
                i.isFold = true;
                i.deepSeekAnswer = i.allAnswer.split(deepSeekFooter)[0];
                i.answer = i.allAnswer.split(deepSeekFooter)[1];
                i.finishDeepSeek = true;
              } else if (i.answer.indexOf(deepSeekHead) != -1) {
                i.allAnswer = i.answer;
                i.isDeepSeek = true;
                i.isFold = true;
                i.deepSeekAnswer = i.answer;
                i.finishDeepSeek = true;
                i.answer = "";
              } else if (i.answer.indexOf(imgContentHead) != -1) {
                i.isImage = true;
              }
              if (i.message_files.length > 0) {
                let message_files = [];
                for (let j of i.message_files) {
                  if (j.belongs_to != "assistant") {
                    message_files.push(j);
                  }
                }
                i.message_files = message_files;
              }
            }
            vm.chatContent.unshift(...data);
            if (!params.first_id) {
              vm.scrollToBottom(true);
            }
            // 这里遍历一下this.chatContent中的所有的项
            vm.$nextTick(async () => {
              // 时间复杂度（n）
              console.log(vm.chatContent.length);
              for (let i in vm.chatContent) {
                // 找到尚未进行匹配特殊抬头的项
                if (
                  vm.chatContent[i].isBusiness === undefined ||
                  vm.chatContent[i].isBusiness === null
                ) {
                  // 如果字符串长度还没有特殊抬头的长度要长 直接置为false
                  if (
                    vm.chatContent[i].answer.length < specialCodeHead.length
                  ) {
                    vm.chatContent[i].isBusiness = false;
                    continue;
                  }
                  let length = specialCodeHead.length;
                  let currentHead = vm.chatContent[i].answer.substring(
                    0,
                    length
                  );
                  // 如果匹配到的特殊抬头
                  if (currentHead == specialCodeHead) {
                    vm.chatContent[i].isBusiness = true;
                  } else {
                    vm.chatContent[i].isBusiness = false;
                  }
                }
              }
              setTimeout(() => {
                vm.scrollToBottom(true);
              }, 300);
            });
          } else {
            Toast("网络异常");
          }
        })
        .catch((err) => {
          console.log(err);
          Toast("网络异常");
        });
    },
    // 根据ai_app_code查询是否存在会话
    findConversation: async function () {
      let params = {
        ai_app_code: vm.currentChat_ai_app_code,
      };
      let result = await Http.findConversation(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            return res.originalData.data;
          } else {
            return false;
          }
        })
        .catch((err) => {
          console.log(err);
          vm.$toast("网络异常");
          return false;
        });
      return result;
    },
    // 点击表单其他区域
    clickFormShadeBox: function () {
      vm.showChatInputsDialog = false;
    },
    // 校验用户inputs表单
    checkForm: function () {
      if (vm.chatDetail && vm.chatDetail.inputParam == 1) {
        for (let i of vm.user_input_form) {
          if (i.required && !i.value) {
            return i.label;
          }
        }
      }
      return true;
    },
    sendMessageByEnter: function () {
      // 这里判断下 inputContent 是否为空
      if (vm.inputContent.trim() == "") {
        return;
      }
      vm.sendMessage(vm.inputContent);
    },
    // 发送消息
    sendMessage: async function (message) {
      console.log(message);
      // 如果此时正在生成内容，直接toast用户
      if (vm.isGenerating) {
        Toast("回复生成中，请稍等");
        return;
      }
      let checkForm = vm.checkForm();
      if (checkForm !== true) {
        vm.$toast(`请填写${checkForm}`);
        vm.showChatInputsDialog = true;
        return;
      }
      if (vm.isVip == false && vm.chatDetail && vm.chatDetail.vipOnly) {
        vm.showVipOnlyDialog = true;
        return;
      }
      // 如果发现本地没有ws实例
      // 那么就创建一个
      if (!vm.ws) {
        let result = await vm.createWS();
        // 如果创建失败
        if (!result) {
          Toast("网络异常,连接建立失败");
          return;
        }
      }
      vm.requestId = new Date().getTime();
      let params = {
        query: message || vm.inputContent,
        ai_app_code: vm.currentChat_ai_app_code,
        clientType: window.localStorage.getItem("clientType_AI"),
        requestId: vm.requestId,
      };
      if (vm.chatDetail.inputParam === 1) {
        let obj = {};
        for (let i of vm.user_input_form) {
          if (i.value) {
            obj[i.variable] = i.value;
          }
        }
        console.log(obj);
        console.log(JSON.stringify(obj));
        params.inputs = JSON.stringify(obj);
      }
      if (vm.currentChat_conversation_id) {
        params.conversation_id = vm.currentChat_conversation_id;
      }
      //如果存在待上传的文件
      if (vm.filesWaitUpload && vm.filesWaitUpload.length > 0) {
        params.files = JSON.stringify(vm.filesWaitUpload);
      }
      vm.suggestedData = [];
      console.log("===params", params);
      if (vm.ws.readyState === WebSocket.OPEN) {
        // 手动让textarea失焦
        vm.$refs["textarea"].blur();
        vm.responseTempStr = "";
        vm.isMatchSpecialHead = 0;
        vm.ws.send(JSON.stringify(params));
        vm.chatDetail.usedCount = vm.chatDetail.usedCount + 1;
        vm.currentCount = vm.currentCount + 1;
        vm.message_end_error = true;
        vm.isGenerating = true;
        let obj = {
          query: message || vm.inputContent,
          files: vm.completeFiles,
          answer: "",
          deepSeekAnswer: "",
          allAnswer: "",
          isDeepSeek: false,
          isFold: false,
          requestId: vm.requestId,
          isImage: false,
          isBusiness: false,
          businessType: null,
          businessContent: null,
        };
        if (vm.currentChat.extraCode == "llceo") {
          vm.needPlayCeoAnimation = true;
          vm.ceoAnimationPlayOver = false;
          vm.ceoAnimationMessageEnd = false;
          obj.finishSpecialThink = false;
          obj.isSpecialThink = true;
          obj.ceoAnimateArr = [];
        }
        vm.currentHasAutoPlaying = false;
        vm.chatContent.push(obj);
        vm.currentQuery = message || vm.inputContent;
        vm.inputContent = "";
        vm.textareaResize();
        //清空输入框内的文件
        vm.dataFromUpload = [];
        //清空待上传的文件
        vm.completeFiles = [];
        vm.filesWaitUpload = [];
        vm.$refs["textarea"].focus();
        // 停止播放上一段语音
        if (vm.audioPlayer) {
          vm.clickStopPlayBtn();
        }
        if (!vm.hideTTSBtn) {
          // 这里立刻创建播放器  ————————————————————————————————
          vm.audioPlayer = new AudioPlayer(vm.playerCallback);
          const au = vm.audioPlayer.audio;
          const ctx = vm.audioPlayer.audioContext;
          /* ---------- 手势栈内：解锁 + 静音占坑 ---------- */
          await ctx.resume(); // 解锁 Web‑Audio
          au.muted = true; // 静音
          try {
            au.play();
          } catch (_) { } // 在手势中 play，拿到播放许可
          const onCanPlay = () => {
            au.muted = false; // 真正发声
            au.removeEventListener("canplay", onCanPlay);
          };
          au.addEventListener("canplay", onCanPlay);
        }
        // 结束  ————————————————————————————————
        // 记录本轮提问的自动播放状态
        vm.isAutoPlayVoice_current = vm.isAutoPlayVoice;
        vm.$nextTick(() => {
          lottie.loadAnimation({
            container: document.getElementById("AI_generating"), // the dom element that will contain the animation
            renderer: "svg",
            loop: true,
            autoplay: true,
            animationData: loadingJSON, // the path to the animation json
          });
          vm.isAutoScroll = true;
          vm.scrollToBottom(true);
        });
      } else {
        console.log("websocket连接未打开");
      }
    },
    // 创建webSocket
    createWS: async function () {
      return new Promise((resolve, reject) => {
        let url = `${process.env.VUE_APP_WS_HOST}${API.question
          }?appId=${window.localStorage.getItem(
            "appId_AI"
          )}&sId=${window.localStorage.getItem("sessionId_AI")}`;
        console.log(url);
        vm.ws = new WebSocket(url);
        vm.ws.onopen = () => {
          console.log("WebSocket 连接已经建立。");
          resolve(true);
        };
        vm.ws.onmessage = async (event) => {
          // 如果此时并不是正常生成内容状态，直接将返回结果舍弃
          if (!vm.isGenerating) {
            return;
          }
          let result = JSON.parse(event.data);
          console.log("收到服务器消息：", result.event);
          // 服务器异常
          if (result.code == "CHAT_EXCEPTION") {
            console.log("服务器异常");
            vm.$toast(result.msg || "网络异常");
            vm.stopGenerating();
            return;
          }
          // 游客对话条数达到限额
          if (result.code == "GUEST_OVER_LIMIT") {
            console.log("游客对话条数达到限额");
            vm.isGuestOverLimit = true;
            vm.$toast(result.msg || "网络异常");
            vm.stopGenerating();
            vm.openLoginDialog();
            return;
          }
          // 如果发现返回的requestId跟当前的requestId不一致  直接舍弃
          if (vm.requestId != result.requestId) {
            return;
          }
          // 收到回复
          if (result.event == "message") {
            vm.message_end_error = false;
            if (vm.currentChat.extraCode == "llceo") {
              if (vm.needPlayCeoAnimation) {
                vm.playCeoAnimation(result);
                vm.needPlayCeoAnimation = false;
              }
              if (vm.ceoAnimationPlayOver == false) {
                vm.responseTempStr = vm.responseTempStr + result.answer;
                return;
              }
            }
            vm.onMessage(result);
          } else if (result.event == "modal_card") {
            console.log("modal_card", result);
            vm.modal_card = result;
          }
          // 结束回复
          else if (result.event == "message_end") {
            if (vm.currentChat.extraCode == "llceo") {
              if (vm.ceoAnimationPlayOver == false) {
                vm.ceoAnimationMessageEnd = true;
                return;
              }
            }
            vm.messageEnd(result);
          }
        };
        vm.ws.onerror = (event) => {
          console.error("WebSocket 连接出现错误：", event);
          vm.ws = null;
          reject(false);
        };
        vm.ws.onclose = (event) => {
          console.log("WebSocket 连接已经关闭。", event);
          vm.ws = null;
          reject(false);
        };
      }).catch((err) => {
        console.log(err);
        return false;
      });
    },
    // 接受消息
    onMessage: function (result) {
      // 如果当前尚未开始匹配或已经匹配成功
      if (
        vm.isMatchSpecialHead == 0 ||
        vm.isMatchSpecialHead == 1 ||
        vm.isMatchSpecialHead == 2 ||
        vm.isMatchSpecialHead == 3
      ) {
        vm.responseTempStr = vm.responseTempStr + result.answer;
      }
      // 如果当前状态是尚未匹配
      if (vm.isMatchSpecialHead == 0) {
        // console.log("当前状态是未匹配");
        // console.log(vm.responseTempStr);
        // 业务编码是否匹配失败
        let specialCodeCheckFail = false;
        let deepSeekCheckFail = false;
        let imgContentCheckFail = false;
        //  两种情况都要匹配
        // 先匹配是不是深度思考的特殊抬头
        if (vm.responseTempStr.length >= deepSeekHead.length) {
          let length = deepSeekHead.length;
          let currentHead = vm.responseTempStr.substring(0, length);
          if (currentHead == deepSeekHead) {
            // 匹配成功  深度思考
            // console.log("匹配成功，深度思考");
            vm.isMatchSpecialHead = 2;
          } else {
            // console.log("匹配失败，深度思考");
            deepSeekCheckFail = true;
          }
        }
        // 在匹配图片的特殊抬头
        if (vm.responseTempStr.length >= imgContentHead.length) {
          let length = imgContentHead.length;
          let currentHead = vm.responseTempStr.substring(0, length);
          if (currentHead == imgContentHead) {
            // 匹配成功 图片
            vm.isMatchSpecialHead = 3;
          } else {
            imgContentCheckFail = true;
          }
        }
        // 在匹配业务编码的特殊抬头
        if (vm.responseTempStr.length >= specialCodeHead.length) {
          // 开始查询是否匹配成功
          let length = specialCodeHead.length;
          let currentHead = vm.responseTempStr.substring(0, length);
          if (currentHead == specialCodeHead) {
            // 匹配成功  业务编码
            // console.log("匹配成功，业务编码");
            vm.isMatchSpecialHead = 1;
          } else {
            // console.log("匹配失败，业务编码");
            specialCodeCheckFail = true;
          }
        }
        if (specialCodeCheckFail && deepSeekCheckFail && imgContentCheckFail) {
          // 匹配失败
          vm.isMatchSpecialHead = 99;
        }
      }
      // 如果匹配到了  业务编码特殊抬头
      if (vm.isMatchSpecialHead == 1) {
        // 这里不做任何操作 等待message_end  在message_end生命周期中渲染dom
        // console.log("匹配到了特殊抬头");
      }
      // 如果匹配到了  深度思考 特殊抬头
      else if (vm.isMatchSpecialHead == 2) {
        // console.log("匹配到了深度思考");
        let answer = vm.responseTempStr || result.answer;
        // 这里要判断下  深度思考 是否思考完毕
        vm.responseTempStr = "";
        vm.insertDeepSeekAnswer(
          result.conversation_id,
          result.message_id,
          answer
        );
        vm.task_id = result.task_id;
        // vm.scrollToBottom(false);
      }
      // 如果匹配到了图片
      else if (vm.isMatchSpecialHead == 3) {
        let answer = vm.responseTempStr || result.answer;
        vm.responseTempStr = "";
        vm.insertAnswer(result.conversation_id, result.message_id, answer);
        vm.task_id = result.task_id;
      }
      // 如果没匹配到
      else if (vm.isMatchSpecialHead == 99) {
        let answer = vm.responseTempStr || result.answer;
        vm.responseTempStr = "";
        vm.insertAnswer(result.conversation_id, result.message_id, answer);
        vm.task_id = result.task_id;
        // vm.scrollToBottom(false);
      }
    },
    // 消息结束
    messageEnd: async function (result) {
      vm.isGenerating = false;
      vm.task_id = null;
      if (vm.message_end_error) {
        Toast("我溜号了，等会再来找我吧");
        return;
      }
      // 结束回复时，如果chatContent中只有一个值，并且是新对话  代表是首次回复，这时候取一下name
      if (
        vm.newChatInfo &&
        vm.currentChat_ai_app_code == vm.newChatInfo.ai_app_code &&
        vm.chatContent.length == 1
      ) {
        vm.getConversationName();
        // 取完name后 再查一下历史会话列表
        vm.getHistoryMessageList();
      }
      // 结束的时候 再看一下临时字符串的长度是否小于特殊抬头的长度  如果小于，直接渲染结果
      if (
        vm.responseTempStr.length < specialCodeHead.length &&
        vm.isMatchSpecialHead == 0
      ) {
        let answer = vm.responseTempStr;
        vm.responseTempStr = "";
        vm.insertAnswer(result.conversation_id, result.message_id, answer);
        vm.task_id = result.task_id;
        // vm.scrollToBottom(false);
        return;
      }
      // 仅在正常文本回复后  才获取提示语
      if (vm.isMatchSpecialHead == 1) {
        // 这里开始匹配具体的业务编码 生成dom
        // 调用封装方法
        console.log("消息结束，匹配到了特殊抬头");
        console.log(vm.responseTempStr);
        let res = await businessCodeMatch(
          vm.responseTempStr,
          vm.currentChat_ai_app_code
        );
        console.log(res);
        // 如果成功
        if (res.status == "success" || res.status == "error") {
          console.log(result.message_id);
          console.log(vm.modal_card);
          if (vm.modal_card) {
            let modal_card = vm.modal_card.modal_card;
            if (modal_card.bizCode == "BIZ_SESSION_INVALID") {
              // 当 bizSessionId 失效时，可以在这里拦截做处理
              // 暂定  目前暂不做任何处理
            }
            vm.chatContent[vm.chatContent.length - 1].isBusiness = true;
            vm.chatContent[vm.chatContent.length - 1].businessType =
              modal_card.type;
            vm.chatContent[vm.chatContent.length - 1].businessContent =
              modal_card;
            vm.chatContent[vm.chatContent.length - 1].modal_card = modal_card;
          }
          vm.$nextTick(() => {
            setTimeout(() => {
              vm.scrollToBottom(true);
            }, 100);
          });
        }
      } else {
        // 先立即滚动至底部
        vm.$nextTick(() => {
          vm.scrollToBottom(true);
        });
        // 结束回复时，获取提示语
        vm.requestId_getSuggested = Date.now();
        vm.getSuggested(vm.requestId_getSuggested);
      }
    },
    // 停止生成
    stopGenerating: async function () {
      vm.isGenerating = false;
      vm.clickStopPlayBtn();
      let params = {
        task_id: vm.task_id,
        ai_app_code: vm.currentChat_ai_app_code,
        requestId: vm.requestId,
      };
      if (!vm.isLogin) {
        return;
      }
      await Http.stopGenerating(params)
        .then(({ res }) => {
          console.log(res);
          if (res.code == "SUCCESS") {
            vm.task_id = null;
            vm.isGenerating = false;
          } else {
            Toast("网络异常");
          }
        })
        .catch((err) => {
          console.log(err);
          Toast("网络异常");
        });
    },
    // 修改historyList中某个智能体的conversation_id
    updateHistoryListConversationId: function (ai_app_code, conversation_id) {
      for (let i in vm.historyList) {
        if (
          vm.historyList[i].ai_app_code == ai_app_code &&
          vm.newChatInfo &&
          ai_app_code != vm.newChatInfo.ai_app_code
        ) {
          vm.historyList[i].conversation_id = conversation_id;
        }
      }
    },
    // 向chatContent中插入回复
    insertAnswer: function (conversation_id, message_id, answer) {
      let resultAnswer = answer;
      // 如果此时没有conversation_id 那么代表这是一个新的对话
      if (
        vm.currentChat_conversation_id == null ||
        vm.currentChat_conversation_id == ""
      ) {
        vm.currentChat_conversation_id = conversation_id;
        vm.updateHistoryListConversationId(
          vm.currentChat_ai_app_code,
          conversation_id
        );
      }
      // 如果传入的conversation_id跟当前的conversation_id不同的话，直接舍弃
      if (conversation_id != vm.currentChat_conversation_id) {
        console.log("传入的conversation_id跟当前的conversation_id不同");
        return;
      }
      // 先找角标
      let index = -1;
      // 从数组中找到message_id对应的下标  这里效率有点低
      for (let i in vm.chatContent) {
        // 如果找到了  直接往对应的回复中添加新的回复
        if (vm.chatContent[i].id === message_id) {
          index = i;
          vm.chatContent[i].answer = vm.chatContent[i].answer + resultAnswer;
        }
      }
      // 如果没找到  并且 最后一个 chatContent的值中没有Id  那就插到最后一个
      if (index == -1 && !vm.chatContent[vm.chatContent.length - 1].id) {
        index = vm.chatContent.length - 1;
        vm.chatContent[vm.chatContent.length - 1].id = message_id;
        vm.chatContent[vm.chatContent.length - 1].answer = resultAnswer;
        vm.chatContent[vm.chatContent.length - 1].isBusiness = false;
        if (vm.isMatchSpecialHead === 3) {
          vm.chatContent[index].isImage = true;
        }
      }
      // 如果当前尚未播放语音
      if (vm.playingContentIndex == -1 && vm.currentHasAutoPlaying == false) {
        // 如果允许自动播放
        if (vm.isAutoPlayVoice_current) {
          if (vm.isMatchSpecialHead === 3) {
            console.log("该条是图片，不触发自动播放");
            return;
          } else {
            vm.currentHasAutoPlaying = true;
            vm.autoPlay(index);
          }
        }
      }
      vm.scrollToBottom(false);
    },
    // 插入特殊回复(业务编码)
    insertBusinessAnswer: function (conversation_id, message_id) {
      // 如果此时没有conversation_id 那么代表这是一个新的对话
      if (vm.currentChat_conversation_id == null) {
        vm.currentChat_conversation_id = conversation_id;
      }
      // 直接插到最后一个就行
      vm.chatContent[vm.chatContent.length - 1].id = message_id;
      vm.chatContent[vm.chatContent.length - 1].answer = "";
      vm.chatContent[vm.chatContent.length - 1].isBusiness = true;
    },
    // 插入特殊回复（深度思考）
    insertDeepSeekAnswer: function (conversation_id, message_id, answer) {
      // 如果此时没有conversation_id 那么代表这是一个新的对话
      if (vm.currentChat_conversation_id == null) {
        vm.currentChat_conversation_id = conversation_id;
        vm.updateHistoryListConversationId(
          vm.currentChat_ai_app_code,
          conversation_id
        );
      }
      // 如果传入的conversation_id跟当前的conversation_id不同的话，直接舍弃
      if (conversation_id != vm.currentChat_conversation_id) {
        console.log("传入的conversation_id跟当前的conversation_id不同");
        return;
      }
      // 先找角标
      let index = -1;
      // 从数组中找到message_id对应的下标  这里效率有点低
      for (let i in vm.chatContent) {
        if (vm.chatContent[i].id === message_id) {
          index = i;
          break;
        }
      }
      // 如果没找到  并且 最后一个 chatContent的值中没有Id  那就插到最后一个
      if (index == -1 && !vm.chatContent[vm.chatContent.length - 1].id) {
        index = vm.chatContent.length - 1;
        // 初始化
        vm.chatContent[index].answer = "";
        vm.chatContent[index].allAnswer = "";
        vm.chatContent[index].deepSeekAnswer = "";
        vm.chatContent[index].id = message_id;
        vm.chatContent[index].isBusiness = false;
        vm.chatContent[index].isFold = false;
        vm.chatContent[index].finishDeepSeek = false;
        vm.chatContent[index].isDeepSeek = true;
      }
      vm.chatContent[index].allAnswer =
        vm.chatContent[index].allAnswer + answer;
      let allAnswer = vm.chatContent[index].allAnswer;
      let normalAnswer = "";
      let deepSeekAnswer = "";
      // 如果找到了结束符
      if (allAnswer.indexOf(deepSeekFooter) != -1) {
        deepSeekAnswer = allAnswer.split(deepSeekFooter)[0];
        normalAnswer = allAnswer.split(deepSeekFooter)[1];
        vm.chatContent[index].finishDeepSeek = true;
      } else {
        deepSeekAnswer = allAnswer;
      }
      vm.chatContent[index].answer = normalAnswer;
      vm.chatContent[index].deepSeekAnswer = deepSeekAnswer;
      // 如果当前尚未播放语音
      if (vm.playingContentIndex == -1 && vm.currentHasAutoPlaying == false) {
        // 如果允许自动播放
        if (vm.isAutoPlayVoice_current) {
          vm.currentHasAutoPlaying = true;
          vm.autoPlay(index);
        }
      }
      vm.scrollToBottom(false);
    },
    // 折叠思考内容
    foldThinkingContent: function (index) {
      vm.chatContent[index].isFold = !vm.chatContent[index].isFold;
    },
    // 停止自动滚动
    stopAutoScroll: function () {
      vm.isAutoScroll = false;
    },
    //接收子组件（文件上传控件）传值，文件上传数据
    sendFilesData(data) {
      vm.dataFromUpload = data;
      //会将会话框区域增高，设置滑动到底部
      vm.$nextTick(() => {
        vm.scrollToBottom(true);
      });
    },
    //接收子组件（文件预览控件）传值，待与会话一起上传的文件
    sendFilesWaitUpload(data, completeFiles) {
      console.log(data, 123);
      vm.filesWaitUpload = data;
      vm.completeFiles = completeFiles;
    },
    // 列表滚动方法
    contentOnScroll: function (e) {
      if (
        e.target.scrollHeight - e.target.scrollTop >
        e.target.offsetHeight * 1.3
      ) {
        // 显示箭头
        // console.log("显示箭头");
        vm.ShowScrollToBottomBtn = true;
      } else {
        // 隐藏箭头
        // console.log("隐藏箭头");
        vm.ShowScrollToBottomBtn = false;
      }
    },
    // chatContentBox滚动监听
    onChatContentScroll: function (e) {
      const scrollTop = e.target.scrollTop;
      const scrollHeight = e.target.scrollHeight;
      const clientHeight = e.target.clientHeight;
      const distanceToBottom = scrollHeight - scrollTop - clientHeight;

      // 当距离底部大于50px时显示按钮
      if (distanceToBottom > 50) {
        vm.showGoToBottomBtn = true;
      } else {
        vm.showGoToBottomBtn = false;
      }
    },
    // 前往底部
    goToBottom: function () {
      const chatContentBox = vm.$refs.chatContentBox;
      if (chatContentBox) {
        chatContentBox.scrollTo({
          top: chatContentBox.scrollHeight,
          behavior: "smooth",
        });
      }
    },
    // 点击打开一个新对话
    clickOpenNewChat: async function () {
      // 如果当前不是宽屏，关闭侧边栏
      if (!vm.isWideScreen) {
        vm.showLeftSideBar = false;
      }
      // 如果当前未登录
      if (!vm.isLogin) {
        vm.showLoginDialog = true;
        return;
      }

      // 如果当前已经是新对话，并且没有会话id，则不进行任何操作
      if (!vm.currentChat_conversation_id && vm.currentChat.type == "normal") {
        return;
      }
      vm.currentChat = vm.newChatInfo;
      vm.currentChat_conversation_id = null;
      vm.currentChat_ai_app_code = vm.newChatInfo.ai_app_code;
      vm.loading = true;
      await vm.switchChat();
      vm.loading = false;
    },
    // 切换对话
    switchChat: async function () {
      // 尝试关闭ws连接
      if (vm.ws) {
        vm.ws.close();
        vm.ws = null;
      }
      // 切换对话时，清空requestId_getSuggested
      vm.requestId_getSuggested = null;
      vm.isGenerating = false;
      //   清空历史消息
      vm.chatContent = [];
      //   清空提示语
      vm.suggestedData = [];
      //   清空开场白
      vm.prologue = "";
      vm.prologueList = [];
      vm.chatContentHasMore = false;
      // 清空输入框
      vm.inputContent = "";
      vm.textareaResize();
      // 禁用文件上传
      vm.showFileUpload = false;
      // 清空文件上传数据
      vm.dataFromUpload = [];
      vm.filesWaitUpload = [];
      vm.completeFiles = [];
      // 清空举报原因
      vm.currentReportType = null;
      vm.reportContent = "";
      // 停止播放
      vm.clickStopPlayBtn();
      // 根据ai_app_code获取智能体详情

      await vm.getAgentInfo();
      await vm.getAutoTTSInfo();
      // 如果当前打开了自动播放
      if (vm.isAutoPlayVoice) {
        // 查一下需不需要关闭
        let resultTTS = await vm.getTTSLimit();
        if (resultTTS.code == "TTS_LIMIT") {
          // 关闭
          vm.switchAutoTTS(0);
        }
      }
      await vm.getPrologue();
      await vm.getChatDetail();
      if (vm.currentChat_conversation_id) {
        // 如果当前有conversation_id，则获取历史记录
        await vm.getHistoryMessageDetail();
        // 顺便获取name
        await vm.getConversationName();
        // 顺便加载提示语
        setTimeout(async () => {
          if (
            vm.chatContent.length > 0 &&
            vm.chatContent[vm.chatContent.length - 1].isBusiness == false
          ) {
            vm.requestId_getSuggested = Date.now();
            await vm.getSuggested(vm.requestId_getSuggested);
          }
        }, 500);
      }
      // 如果当前地址栏的share_ai_app_code不等于当前的ai_app_code 那么就更新地址栏
      if (vm.$route.query.share_ai_app_code != vm.currentChat_ai_app_code) {
        // 如果ai_app_code不是新对话 那么就把ai_app_code放到地址栏中
        if (vm.currentChat_ai_app_code != vm.newChatInfo.ai_app_code) {
          vm.$router.replace({
            query: {
              share_ai_app_code: vm.currentChat_ai_app_code,
            },
          });
        }
        // 如果是新对话 那么要清空share_ai_app_code
        else {
          if (vm.$route.query.share_ai_app_code) {
            vm.$router.replace({});
          }
        }
      }
      // 如果当前智能体需要用户输入参数，则展示表单
      if (vm.chatDetail.inputParam == 1) {
        vm.showChatInputsDialog = true;
      }
    },
  };
}
